import { Loader2, CheckCircle2, AlertTriangle, Clock } from 'lucide-react';
import clsx from 'clsx';

export type RecordSyncState = 'draft' | 'queued' | 'syncing' | 'synced' | 'failed';

interface Props {
  state: RecordSyncState;
  /** When provided, shows a tail label. Otherwise icon-only. */
  label?: string;
  className?: string;
}

/** Per-record sync state pill — shown on the well row in EventDetailPage and
 *  in the wizard's review step. Clears up the "did my reading make it to the
 *  queue or is it actually uploaded?" ambiguity the audit flagged. */
export function SyncBadge({ state, label, className }: Props) {
  const cfg = CFG[state];
  const Icon = cfg.icon;
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 text-[10px] tracking-widest uppercase',
        'px-1.5 py-0.5 rounded ring-1',
        cfg.bg, cfg.text, cfg.ring,
        className,
      )}
      title={cfg.title}
    >
      <Icon className={clsx('h-3 w-3', cfg.iconCls)} strokeWidth={2.4} />
      {label && <span>{label}</span>}
    </span>
  );
}

const CFG: Record<RecordSyncState, {
  icon: typeof Loader2;
  bg: string;
  text: string;
  ring: string;
  iconCls: string;
  title: string;
}> = {
  draft:   { icon: Clock,        bg: 'bg-mono-700/40',    text: 'text-mono-200',   ring: 'ring-mono-600/40',    iconCls: '',             title: 'Draft saved locally; not yet submitted.' },
  queued:  { icon: Clock,        bg: 'bg-amber-500/15',   text: 'text-amber-300',  ring: 'ring-amber-500/30',   iconCls: '',             title: 'Queued for upload on next sync.' },
  syncing: { icon: Loader2,      bg: 'bg-cyan-500/15',    text: 'text-cyan-300',   ring: 'ring-cyan-500/30',    iconCls: 'animate-spin', title: 'Uploading…' },
  synced:  { icon: CheckCircle2, bg: 'bg-emerald-500/15', text: 'text-emerald-300',ring: 'ring-emerald-500/30', iconCls: '',             title: 'Submitted to ARGOS.' },
  failed:  { icon: AlertTriangle,bg: 'bg-red-500/15',     text: 'text-red-300',    ring: 'ring-red-500/30',     iconCls: '',             title: 'Submission failed; will retry.' },
};
